import { useEffect } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function Terms() {
      useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
   <>
     <div className="page-wrapper">
   <Header />
    <div className="content-wrapper pt-50">
        <section className="terms">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="flex-1 lg:max-w-[1000px] lg:mx-auto lg:pt-24 pt-20 pb-12 lg:pb-16">
                        <div className="lg:px-6 px-4">
                            <div className="lg:mb-12 mb-8">
                            <h1>Terms and Conditions</h1>
                            <p className="text-gray-600 text-sm">Last Updated: January 2026</p>
                            </div>
                            <div className="prose prose-gray max-w-none">
                            <section className="mb-8 pt-30">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                1. Introduction
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-4">
                                Welcome to <strong>LandPanda.com</strong> ("Platform", "we", "us",
                                "our"), owned and operated by{" "}
                                <strong>DIAL ERP TECHNOLOGIES LIMITED</strong>. These Terms and
                                Conditions ("Terms") govern your access to and use of the website and
                                services available at https://landpanda.com.
                                </p>
                                <p className="text-gray-700 leading-relaxed">
                                By accessing, browsing, or using the Platform, you agree to be bound
                                by these Terms. If you do not agree, you must discontinue use of the
                                Platform.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                2. Nature of the Platform
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                LandPanda.com is a real estate information and listing platform that:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>
                                    Displays property and project information retrieved from public
                                    sources, including RERA portals
                                </li>
                                <li>
                                    Allows users, owners, developers, and brokers to submit property and
                                    project listings
                                </li>
                                <li>
                                    Provides tools for searching, viewing, and contacting listing
                                    parties
                                </li>
                                </ul>
                                <p className="text-gray-700 leading-relaxed">
                                We are not a real estate broker, agent, developer, legal advisor, or
                                financial advisor, and we do not participate in any transaction
                                between buyers and sellers.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                3. Eligibility
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                You must be at least 18 years of age and legally capable of entering
                                into a binding agreement under Indian law to use this Platform.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                4. User Accounts (If Applicable)
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                If you create an account on the Platform:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>
                                    You are responsible for maintaining the confidentiality of your
                                    login credentials
                                </li>
                                <li>
                                    You agree to provide accurate, current, and complete information
                                </li>
                                <li>
                                    You are responsible for all activity that occurs under your account
                                </li>
                                <li>
                                    We reserve the right to suspend or terminate accounts that violate
                                    these Terms.
                                </li>
                                </ul>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                5. Listings and User Content
                                </h2>
                                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                                5.1 Responsibility for Listings
                                </h3>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                Any information, data, images, or content you submit to the Platform,
                                including property or project listings, is your sole responsibility.
                                </p>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                You represent and warrant that:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>You have the legal right and authority to post the content</li>
                                <li>The information is accurate, lawful, and not misleading</li>
                                <li>The content does not infringe any third-party rights</li>
                                </ul>
                                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                                5.2 Public Data Display
                                </h3>
                                <p className="text-gray-700 leading-relaxed">
                                We may display information retrieved from publicly available sources
                                such as RERA websites. While we attempt to present such information
                                accurately, we do not guarantee that it is complete, current, or
                                error-free.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                6. Disclaimer of Accuracy
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                All property and project information is provided on an "as-is" and
                                "as-available" basis.
                                </p>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                We do not verify or authenticate:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>Ownership</li>
                                <li>Regulatory approvals</li>
                                <li>Pricing</li>
                                <li>Legal compliance</li>
                                <li>Project status</li>
                                </ul>
                                <p className="text-gray-700 leading-relaxed">
                                You agree to conduct your own independent due diligence before
                                entering into any transaction.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                7. Prohibited Use
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">You agree not to:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>Post false, fraudulent, or misleading information</li>
                                <li>Impersonate any person or entity</li>
                                <li>Use bots, scrapers, or automated tools without authorization</li>
                                <li>Upload malicious software or harmful code</li>
                                <li>Attempt unauthorized access to the Platform</li>
                                </ul>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                8. Intellectual Property
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-4">
                                All content, trademarks, logos, designs, and software on the Platform
                                are the property of DIAL ERP TECHNOLOGIES LIMITED or its licensors and
                                are protected by applicable intellectual property laws.
                                </p>
                                <p className="text-gray-700 leading-relaxed">
                                You may not copy, reproduce, distribute, or commercially exploit any
                                part of the Platform without written permission.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                9. Third-Party Links
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                The Platform may contain links to third-party websites, including
                                government portals such as RERA. We are not responsible for their
                                content, privacy practices, or accuracy.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                10. Limitation of Liability
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                To the maximum extent permitted by law, DIAL ERP TECHNOLOGIES LIMITED
                                and LandPanda.com shall not be liable for any direct, indirect,
                                incidental, or consequential damages arising from:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>Use of the Platform</li>
                                <li>Reliance on listings or public data</li>
                                <li>Transactions between users</li>
                                </ul>
                                <p className="text-gray-700 leading-relaxed">
                                Your sole remedy is to discontinue use of the Platform.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                11. Indemnification
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                You agree to indemnify and hold harmless DIAL ERP TECHNOLOGIES
                                LIMITED, its directors, employees, and partners from any claims,
                                losses, or legal actions arising out of:
                                </p>
                                <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                                <li>Your use of the Platform</li>
                                <li>Your content or listings</li>
                                <li>Your violation of these Terms</li>
                                </ul>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                12. Termination
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                We reserve the right to suspend or terminate your access to the
                                Platform at our sole discretion, without notice, if you violate these
                                Terms or applicable law.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                13. Governing Law and Jurisdiction
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-4">
                                These Terms shall be governed by the laws of India.
                                </p>
                                <p className="text-gray-700 leading-relaxed">
                                All disputes shall be subject to the exclusive jurisdiction of the
                                courts in New Delhi, Delhi, India.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                14. Changes to Terms
                                </h2>
                                <p className="text-gray-700 leading-relaxed">
                                We may update these Terms from time to time. Continued use of the
                                Platform after changes means you accept the revised Terms.
                                </p>
                            </section>
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                15. Contact Information
                                </h2>
                                <p className="text-gray-700 leading-relaxed mb-3">
                                For any questions or concerns regarding these Terms, you may contact:
                                </p>
                                <div className="bg-teals rounded-lg p-6 border border-teal-200 mb-50">
                                <p className="text-gray-900 font-semibold mb-2">
                                    DIAL ERP TECHNOLOGIES LIMITED
                                </p>
                                <p className="text-gray-700 mb-1">
                                    Email:{" "}
                                    <a
                                    href="mailto:info@landpanda.com"
                                    className="text-teal-600 hover:text-teal-700 font-medium"
                                    >
                                    info@landpanda.com
                                    </a>
                                </p>
                                <p className="text-gray-700 mb-1">
                                    Mobile:{" "}
                                    <a
                                    href="tel:+917992799230"
                                    className="text-teal-600 hover:text-teal-700 font-medium"
                                    >
                                    +91 7992799230
                                    </a>
                                </p>
                                <p className="text-gray-700 mb-0" style={{marginBottom:0}}>
                                    Address: PADMA TOWER-2, 608, 6TH FLOOR, RAJENDRA PLACE, New Delhi,
                                    Delhi, India
                                </p>
                                </div>
                            </section>
                            </div>
                          
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>

   <Footer /></div>
   </>
  );
}

export default Terms;
